// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { jsx as _jsx } from "react/jsx-runtime";
import gemCategoryParseIcon from '../../../assets/new_gems/Category/GemCategoryParse.svg?inline';
import React from 'react';
export const GemCategoryParse = (props)=>{
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: gemCategoryParseIcon,
        alt: "GemCategoryParseImage"
    });
};
